import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useGetMenuItemsQuery } from '../../../Apis/menuItemApi';
import { menuItemModel } from '../../../Interfaces';
import { setMenuItem } from '../../../Storage/Redux/menuItemSlice';
import BaseURL from '../../../Utility/BaseURL';
import Footer from '../../Layout/Footer';
import { MainLoader } from '../Common';
import MenuItemCard from './MenuItemCard';
function MenuItemList() {
    //const [menuItems, setMenuItems] = useState<menuItemModel[]>([])
    const {data, isLoading} = useGetMenuItemsQuery(null)
    const dispatch = useDispatch()
    // async function list(){
    //   let r = await axios.get(`${BaseURL}MenuItem`)
    //   setMenuItems(r.data.result)
    //   console.log(r.data.result)
    // }
    useEffect(()=>{
      if(!isLoading){
         dispatch(setMenuItem(data.result))
      }
    },[isLoading])

    if(isLoading){
      return (
        <MainLoader/>
        )
    }
  return (
    <>
    <div className='container row mx-auto'>
     {data.result.length > 0 && data.result.map((menuItem: menuItemModel,index: number)=>(
      <MenuItemCard menuItem = {menuItem} key={index}/>
     ))
     }
    </div>
    <Footer/>
    </>
  )
}

export default MenuItemList